import React, { useState, useEffect } from "react";
import { Formik, Form, FieldArray, Field } from "formik";
import { MdOutlineRemoveCircle } from "react-icons/md";
import { useNavigate, Link, useLocation } from "react-router-dom";
import {getAuthorization} from "../../../axios/AxiosAut";
import Itemsdata from "./table/Itemsdata";
import Pickitemsdata from "./table/Pickitemsdata";
import EditUserForm from "./EditUserForm";
import EditGroupForm from "./EditGroupForm";
import Swal from "sweetalert2"

function EditScheduleJob() {
  const [status, setStatus] = useState(1); // 0: no show, 1: show yes, 2: show no.
const location =useLocation();
const {state} = location;
const assigned_to= state;
  const radioHandler = (status) => {
    setStatus(status);
  };
 
  const Navigate = useNavigate();

  // User scheduler form
  const UserInitialValues = {
    name: "",
    assigned_to: "staff",
    type: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    staff:{
      id: ""
    },
    customer: ""
    // contacts:[]
  };
  const UserOnSubmit = (values, onSubmitProps) => {
    console.log("User values", values)
    getAuthorization()
    .post("company/create_schedules/", values)
    .then((res) => {
      Swal.fire({
        position: "top-end",
        title: "Schedule Created!",
        showConfirmButton: false,
        timer: 3500,
        showClass: {
          popup: "animate__animated animate__fadeInRight",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutRight",
        },
        width: 300,
        color: "#FFFFFF",
        background: "#2A91D7",
        backdrop: `rgba(0,0,0,0)`,
      });
      Navigate("/dashboard/management/scheduler-dashboard")
    })
    .catch((err) => {
      console.log("Error in creating schedule", err);
      onSubmitProps.setSubmitting(false);
    });

  };

 // Group scheduler form
 const GroupInitialValues = {
  name: "",
  assigned_to: "group",
  type: "",
  start_date: "",
  end_date: "",
  start_time: "",
  end_time: "",
  group:{
    id: ""
  },
  customer: ""
  // contacts:[]
};
const GroupOnSubmit = (values, onSubmitProps) => {
  console.log("Group values", values)
  getAuthorization()
    .post("company/create_schedules/", values)
    .then((res) => {
      Swal.fire({
        position: "top-end",
        title: "Schedule Created!",
        showConfirmButton: false,
        timer: 3500,
        showClass: {
          popup: "animate__animated animate__fadeInRight",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutRight",
        },
        width: 300,
        color: "#FFFFFF",
        background: "#2A91D7",
        backdrop: `rgba(0,0,0,0)`,
      });
      Navigate("/dashboard/management/scheduler-dashboard")
    })
    .catch((err) => {
      console.log("Error in creating schedule", err);
      onSubmitProps.setSubmitting(false);
    });
};
  
  return (
    <>
      <main className="max-w-full  py-4">
        <div className="flex flex-col justify-items-center ml-8">
          <h2 className="font-Montserrat text-xl font-bold text-black">
           Edit Schedular Job
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>

          
          <div className="">
            {assigned_to === "staff" && (
              <div className=" mt-8">
          <div className="flex flex-col justify-items-center">
            <Formik
              initialValues={UserInitialValues}
              onSubmit={UserOnSubmit}
              //   validationSchema={validationSchema}
              //   validateOnMount
            >
              <Form>
                <EditUserForm/>
                <div className="flex flex-row justify-center space-x-128 my-10">
                    <button
                      type="button"
                      className="text-red-600 font-Montserrat font-medium text-lg"
                      onClick={() => Navigate("/dashboard/management/scheduler-dashboard")}
                    >
                      Go Back
                    </button>
                    <Field>
                      {(props) => {
                        const { field, form, meta } = props;
                        const { isSubmitting } = form;
                        return (
                          <>
                            {!isSubmitting ? (
                              <button
                                type="submit"
                                {...(form.isValid
                                  ? {
                                      className:
                                        "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow",
                                    }
                                  : {
                                      disabled: true,
                                      className:
                                        "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow opacity-50 cursor-not-allowed",
                                    })}
                              >
                                Save Schedule
                              </button>
                            ) : (
                              <button
                                disabled
                                className="font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow "
                              >
                                <div className="flex items-center justify-center space-x-2 animate-pulse">
                                  <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                                  <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                  <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                </div>
                              </button>
                            )}
                          </>
                        );
                      }}
                    </Field>
                 </div>
              </Form>
            </Formik>
      </div>
              </div>
            )}
            {assigned_to === "group" && (
              <div className="mt-8">
                <div className="flex flex-col justify-items-center">
            <Formik
              initialValues={GroupInitialValues}
              onSubmit={GroupOnSubmit}
              //   validationSchema={validationSchema}
              //   validateOnMount
            >
              <Form>
                <EditGroupForm/>
              <div className="flex flex-row justify-center space-x-128 my-10">
          <button
            type="button"
            className="text-red-600 font-Montserrat font-medium text-lg"
            onClick={() => Navigate("/dashboard/management/scheduler-dashboard")}
          >
            Go Back
          </button>
          <Field>
            {(props) => {
              const { field, form, meta } = props;
              const { isSubmitting } = form;
              return (
                <>
                  {!isSubmitting ? (
                    <button
                      type="submit"
                      {...(form.isValid
                        ? {
                            className:
                              "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow",
                          }
                        : {
                            disabled: true,
                            className:
                              "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow opacity-50 cursor-not-allowed",
                          })}
                    >
                      Save Schedule
                    </button>
                  ) : (
                    <button
                      disabled
                      className="font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow "
                    >
                      <div className="flex items-center justify-center space-x-2 animate-pulse">
                        <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                        <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                        <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                      </div>
                    </button>
                  )}
                </>
              );
            }}
          </Field>
         </div>
              </Form>
            </Formik>
         </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default EditScheduleJob;
